import { render, staticRenderFns } from "./AddPlace.vue?vue&type=template&id=519caae2&scoped=true&"
import script from "./AddPlace.vue?vue&type=script&lang=js&"
export * from "./AddPlace.vue?vue&type=script&lang=js&"
import style0 from "./AddPlace.vue?vue&type=style&index=0&id=519caae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519caae2",
  null
  
)

export default component.exports